import { render, staticRenderFns } from "./SharerRateDetails.vue?vue&type=template&id=f16b8ffc&scoped=true"
import script from "./SharerRateDetails.vue?vue&type=script&lang=js"
export * from "./SharerRateDetails.vue?vue&type=script&lang=js"
import style0 from "./SharerRateDetails.vue?vue&type=style&index=0&id=f16b8ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16b8ffc",
  null
  
)

export default component.exports